<template>
  <div>
    <a-card class="mb-3">
      <a-form-model :model="form"
                    class="exi_form v2"
                    ref="form"
                    :label-col="{ flex: '0 0 auto' }"
                    :wrapper-col="{ span: 24 }">
        <a-form-model-item label="专家姓名" style="width: 250px">
          <a-input v-model="form.expertName"
                   placeholder="专家姓名"/>
        </a-form-model-item>
        <a-form-model-item label="手机号">
          <a-input v-model="form.mobilePhone"
                   placeholder="手机号"/>
        </a-form-model-item>
        <a-form-model-item label="身份证号" style="width: 300px">
          <a-input v-model="form.idCard"
                   placeholder="身份证号"/>
        </a-form-model-item>
        <a-form-model-item label="专家单位" style="width: 300px">
          <a-input v-model="form.unitName"
                   placeholder="专家单位"/>
        </a-form-model-item>
        <a-form-model-item label="地区">
          <dict-cascader v-model="form.areaAddress"
                         dictKey="COUNTRY.CITY"
                         placeholder="地区选择"
                         style="width: 100%"
          />
        </a-form-model-item>
        <a-form-model-item label="是否在职" prop="isIncumbency">
          <dict-cascader v-model="form.isIncumbency"
                         dictKey="is_incumbency"
                         placeholder="在职选择"
                         style="width: 100%"></dict-cascader>
        </a-form-model-item>
        <a-form-model-item label="标签" style="width: 250px">
          <a-select v-model="form.tagId" allowClear placeholder="标签选择">
            <a-select-option v-for="item in tagList" :key="item.id">{{ item.tagName }}</a-select-option>
          </a-select>
        </a-form-model-item>
        <a-form-model-item label="采购品目名称" style="width: 505px">
          <a-input v-model="form.purchaseItem" @click="openPurchaseItems" read-only
                   placeholder="采购品目名称"/>
        </a-form-model-item>
        <a-button type="primary"
                  @click="onSearch()">查询
        </a-button>
        <a-button @click="reset">重置</a-button>
      </a-form-model>
    </a-card>
    <a-card>
      <template slot="extra">
        <a-radio-group @change="onSearch" v-model="form.state" button-style="solid">
          <a-radio-button :value="undefined">
            全部
          </a-radio-button>
          <a-radio-button v-for="item in SelectExpertStateArr" :value="item.value">
            {{ item.name }}
          </a-radio-button>
        </a-radio-group>
      </template>
      <s-table ref="table"
               :rowSelection="{selectedRowKeys: selectedRowKeys, onChange: onSelectChange}"
               :columns="columns"
               :data="loadData"
               :rowKey="record => record.id"
               :pagination="{ showTotal: (total) => `共 ${total} 条` }">
        <template v-slot:expertName="text,record">
          <a @click.stop="onViewModal(record)">{{ record.expertName }}</a>
          <span>{{ record.idCard }}</span>
        </template>
        <template v-slot:unitName="text,record">
          <div>{{ record.isIncumbencyText }}<br/>{{ record.unitName }}</div>
        </template>
        <template v-slot:tagName="record">
          <a-tag class="mt-1"
                 v-for="(it, index) in record.tagInfoList"
                 :key="it.id"
                 :title="it.tagDetail"
                 :color="it.tagColor">
            {{ it.tagName }}
          </a-tag>
          <a-tag class="mt-1" v-if="record.emergencyFlag==='1'"
                 color="red">
            {{ record.emergencyFlagText }}
          </a-tag>
        </template>
        <template v-slot:action="text,record">
          <a class="link_blue" type="primary" @click="onOpenTag(record)">标签</a>
          <a-divider type="vertical"/>
          <a-popconfirm ok-text="确认" cancel-text="取消"
                        @confirm="onDelete(record.id)">
            <a-icon slot="icon" type="question-circle-o" style="color: red"/>
            <template slot="title">
              删除后该专家的所有资料将无法恢复，
              您确定要删除吗？
            </template>
            <a>删除</a>
          </a-popconfirm>
        </template>
      </s-table>
      <expertView-modal ref="expertView"
                        :visible="evmVisible"
                        :fromType="fromType"
                        @success="afterSuccess"
                        @openEdit="openEdit"
                        @cancel="evmVisible = false"/>
      <choose-search-purchase-item ref="items" :visible="purchaseVisible"
                                   @success="purchaseSuccess"
                                   @cancel="purchaseVisible=false"/>
      <edit-expert-tag-modal @cancel="tagVisible=false" @success="afterTagSuccess"
                             :tagVisible="tagVisible" ref="editExpertTagRef"/>
      <expert-edit ref="expertEditRef" @success="afterSuccess" @openViewExpert="openViewExpert"/>
    </a-card>
  </div>

</template>

<script>
import { PageView } from '@/layouts'
import STable from '@/components/Table'
import DictCascader from '@/components/dict/DictCascader'
import expertViewModal from '@/epp/expertmain/expertInfo/common/ExpertViewModal.vue'
import { ExpertExcel } from '@/epp/export/ExpertUtil'
import {
  ExpertFromType,
  ExpertState,
  ExpertTableArgument,
  SelectExpertStateArr
} from '@/epp/expertmain/expertInfo/utils/ExpertInfoUtil'
import { QueryExpertInfo, DeleteExpertInfo } from '@/epp/expertmain/expertInfo/api/ExpertInfoApi'
import moment from 'moment'
import { GetAllTagList } from '@/epp/expertmain/experttag/util/TagUtil'
import ChooseSearchPurchaseItem from '@/epp/expertmain/purchaseitems/ChooseSearchPurchaseItem.vue'
import EditExpertTagModal from '@/epp/expertmain/expertInfo/common/edititem/EditExpertTagModal.vue'
import ExpertEdit from '@/epp/expertmain/expertInfo/ExpertEdit.vue'
import { IsExpertInfoAdmin } from '@/epp/expertmain/userperm/UserPermUtil'

export default {
  name: 'ExpertSTable',
  components: {
    ExpertEdit,
    EditExpertTagModal,
    ChooseSearchPurchaseItem,
    PageView,
    STable,
    DictCascader,
    expertViewModal,
  },
  props: {
    fromType: {
      type: String,
      default: ExpertFromType.EXPERT_LIST
    },
    showTag: {
      type: String,
      default: '1'
    }
  },
  data () {
    return {
      visible: false,
      tagVisible: false,
      columns: [],
      form: {
        purchaseItem: undefined,
        purchaseItemId: undefined,
        purchaseItemCode: undefined,
        state: ExpertState.STATE.IN_SUCCESS,
        ifDelete: ExpertState.IF_DELETE.NO,
      },
      notExtractTime: null,
      selectedRowKeys: [],
      excelLoading: false,
      evmVisible: false,
      loadData: async (parameter) => {
        const data = { ...parameter, ...this.form }
        return QueryExpertInfo(data)
      },
      ExpertFromType,
      SelectExpertStateArr,
      tagList: [],
      purchaseVisible: false,
      openEditExpertId: '',
      IsExpertInfoAdmin
    }
  },
  activated () {
    this.$refs.table && this.$refs.table.refresh()
  },
  watch: {
    showTag: {
      handler (newVal, oldVal) {
        if (newVal !== oldVal) {
          this.columns = ExpertTableArgument(newVal)
        }
      },
      immediate: true //初始化时立即执行
    }
  },
  computed: {},
  created () {
    this.getTagList()
  },
  methods: {
    openEdit (id) {
      this.openEditExpertId = id
      this.$refs.expertEditRef.loadData(id)
    },
    moment,
    //获取标签列表
    async getTagList () {
      this.tagList = await GetAllTagList()
    },
    //专家信息编辑后刷新table页面
    afterSuccess () {
      this.ESTreFresh(false)
    },
    afterTagSuccess () {
      this.tagVisible = false
      this.ESTreFresh(false)
    },
    onOpenTag (info) {
      this.tagVisible = true
      let expertIdList = []
      if (!Array.isArray(info.id)) {
        expertIdList.push(info.id)
      } else {
        expertIdList = [...info.id]
      }
      this.$refs.editExpertTagRef.onStartLoadData({
        tagId: info.tagIds,
        expertIdList: expertIdList,
        emergencyFlag: info.emergencyFlag
      })
    },
    //导出专家信息
    exportInfo () {
      const that = this
      let data = { ...that.form }
      data.ifDelete = ExpertState.IF_DELETE.NO
      let path = '/api/1/expertmain/expertInfo/export_expert'
      that.excelLoading = true
      ExpertExcel(that, path, data, '专家信息')
      that.excelLoading = false
    },
    onSelectChange (selectedRowKeys) {
      this.selectedRowKeys = selectedRowKeys
      this.$emit('onSelectKey', selectedRowKeys)

    },
    // 重置
    reset () {
      this.form = {
        state: ExpertState.STATE.IN_SUCCESS,
        ifDelete: ExpertState.IF_DELETE.NO
      }
      this.selectedRowKeys = []
      this.$emit('onSelectKey', this.selectedRowKeys)
      this.ESTreFresh()
    },
    // 搜索
    onSearch () {
      this.ESTreFresh()
    },
    // 刷新
    ESTreFresh (toFirstPage = true) {
      this.$refs.table.refresh(toFirstPage)
    },
    //关闭修改或保存修改后打开窗口查看信息
    openViewExpert () {
      this.evmVisible = true
      this.$refs.expertView.loadData(this.openEditExpertId)
    },
    //打开窗口查看信息
    onViewModal (record) {
      this.evmVisible = true
      this.$refs.expertView.loadData(record.id)
    },
    //删除专家信息
    async onDelete (id) {
      try {
        let res = await DeleteExpertInfo(id)
        if (200 !== res.code) {
          this.$message.error('删除失败')
          return
        }
        this.$message.success('删除成功')
        this.ESTreFresh(false)
      } catch (e) {
        this.$message.error('删除失败')
      }
    },
    //打开采购品目
    openPurchaseItems () {
      this.purchaseVisible = true
      let result = []
      if (this.form.purchaseItem) {
        const data = {}
        data['fid'] = this.form.purchaseItemId
        data['fspmmc'] = this.form.purchaseItem
        data['fspmbm'] = this.form.purchaseItemCode
        result.push(data)
      }
      this.$refs.items.preView(result)
    },
    //采购品目选择成功后
    purchaseSuccess (purchaseItem) {
      this.purchaseVisible = false
      this.form.purchaseItem = undefined
      this.form.purchaseItemId = undefined
      this.form.purchaseItemCode = undefined
      if (purchaseItem.length > 0) {
        let data = purchaseItem[0]
        this.form.purchaseItem = data.fspmmc
        this.form.purchaseItemId = data.fid
        this.form.purchaseItemCode = data.fspmbm
      }
    },
  }
}
</script>

<style></style>
